module.exports = __webpack_public_path__ + "static/nancy-pelosi-0038368aba14796a71331835840e1622.jpg";